(function() {
    'use strict';

    angular
        .module('Controllers')
        .directive('ttGrid', ttGridDirective);

    function ttGridDirective(lodash) {
        return {
            restrict: 'EA',
            scope: {
                grid: '=?',
                panelType:'=',
                gridObj: "=?ttGrid"
            },
            replace:true,
            templateUrl: "common/components/grid",
            controller: ttGridDirectiveCtrl,
            link: ttGridDirectiveLink
        };

        function ttGridDirectiveLink(scope, elem) {
            //var grid =elem.find('.k-grid');
            //scope.tempclick = function() {
            //    console.log('testclick','model value',scope.tempval);
            //    var filterHeight = lodash.get(scope,'tempval',50);
            //
            //    grid.css('height','calc(100% - '+filterHeight+'px)');
            //    grid.data('kendoGrid').refresh();
            //};
            if (lodash.has(scope,'grid.datasource.transport.read.url')) elem.data('kendoGrid').dataSource.page(1);

            //console.log('gridObj: ', scope.gridObj);
            if (!lodash.get(scope, 'options.showHeader', false)) {
                elem.find('.k-grid-header').hide();
            }
        }
    }

    function ttGridDirectiveCtrl($scope, $element, DatasourceRegistry, lodash) {
        var gridOption = {};
        this.$onInit = function() {
            gridOption = lodash.get($scope,'grid.options',{});
            gridOption = lodash.merge({
                autoBind:false,
                selectable: 'row',
                sortable: true,
                pageable: {
                    refresh: true
                },
                height: '100%',
                columnMenu: true,
                columns: []
            }, gridOption);

            var datasource = lodash.get($scope,'grid.datasource',{});

            var schema = angular.copy(lodash.get(datasource,'schema',{}));
            datasource.schema = {
                data: function(response) {
                    var dataIndex = lodash.get(schema, 'data', 'data');
                    lodash.forEach(response[dataIndex], function (element) {
                        lodash.forEach(gridOption.columns, function (column) {
                            if (!lodash.has(element, column.field)) {
                                lodash.set(element, column.field, '');
                            }
                        });

                    });
                    //return response.content;
                    return response[dataIndex];
                },

                total: function (response) {
                    return response[lodash.get(schema, 'total', 'total')];
                }
            };

            if (lodash.has(schema, 'groups')) {
                datasource.schema.groups = function(response) {
                    return response[lodash.get(schema,'groups','groups')];
                };
            }

            if (!lodash.has(datasource,'transport')) {
                datasource.transport = {};
            }

            // Reference:
            // http://docs.telerik.com/kendo-ui/api/javascript/data/datasource#configuration-transport.parameterMap
            var pageStartIndex = lodash.get($scope.grid, 'pageStartIndex',1);

            if (!lodash.has(datasource,'transport.parameterMap')) {
                datasource.transport.parameterMap = function (data, type) {
                    if (type == 'read') {
                        return {
                            page: data.page + pageStartIndex - 1 || pageStartIndex,
                            pageSize: data.pageSize || 10,
                            sort: data.sort,
                            filter: data.filter,
                            take: data.take,
                            skip: data.skip
                        };
                    }
                };
            }

            $scope.datasource = new kendo.data.DataSource(datasource);
            DatasourceRegistry.add($scope.panelType.panel_id, $scope.datasource);
            $scope.$on('$destroy', function() {
                DatasourceRegistry.remove($scope.panelType.panel_id);
            });

            gridOption.dataSource = $scope.datasource;

            if (lodash.has(gridOption, 'rowTemlate')) {
                gridOption.rowTemplate = $.proxy(kendo.template(gridOption.rowTemplate), gridOption.datasource);
            }
            $scope.options = gridOption;

            datasource.requestStart = dsRequestStart;
            datasource.requestEnd = dsRequestEnd;
            gridOption.change = dsChange;
            gridOption.dataBound = dsDatabound;
        }

        //var dataValueField = lodash.get($scope, 'grid.datasource.schema')
        function createEventData(event) {
            return {
                targetScope: $scope.grid,
                target: $element,
                event: event
            };
        }

        function dsRequestStart(e) {
            $scope.$emit('action.grid.ds.' + $scope.description + '.requestStart', createEventData(e));
        }

        function dsRequestEnd(e) {
            $scope.$emit('action.grid.ds.' + $scope.description + '.requestEnd', createEventData(e));
        }

        function dsChange(e) {
            $scope.$emit('action.grid.' + $scope.description + '.change', createEventData(e));
        }

        function dsDatabound (e) {
            $scope.$emit('action.grid.' + $scope.description + '.dataBound', createEventData(e));
            var gridElement = e.sender.element;
            if (!(lodash.get(gridOption, 'height', '100%') == '100%')) {
                var dataArea = gridElement.find(".k-grid-content");
                dataArea.css('height','auto');
            }
        }
    }
})();